import { SeedData, Person, Account } from './schema/accountSchema'
import { fullClientList } from './accounts/fullClientList'
import { ensureAllAccountsPeople } from './utils/ensureAccountPeople'
import { validateSeedData, printValidationReport } from './utils/validateData'

const users: Person[] = [
  {
    id: 'u1',
    name: 'Olivia Park',
    role: 'Group Admin',
    role_title: 'Group Admin',
    function: 'Executive',
    side: 'Quad',
    email: 'olivia.park@quad.example',
  },
  {
    id: 'u2',
    name: 'Merritt Lane',
    role: 'Account Admin',
    role_title: 'Account Admin',
    function: 'Operations',
    side: 'Quad',
    email: 'merritt.lane@quad.example',
  },
  {
    id: 'u3',
    name: 'Ava Brooks',
    role: 'Account Member',
    role_title: 'Account Member',
    function: 'Operations',
    side: 'Quad',
    email: 'ava.brooks@quad.example',
  },
  {
    id: 'u4',
    name: 'Liam Chen',
    role: 'Account Member',
    role_title: 'Account Member',
    function: 'Operations',
    side: 'Quad',
    email: 'liam.chen@quad.example',
  },
  {
    id: 'u5',
    name: 'Noah Patel',
    role: 'Account Member',
    role_title: 'Account Member',
    function: 'Operations',
    side: 'Quad',
    email: 'noah.patel@quad.example',
  },
  {
    id: 'u6',
    name: 'Maya Singh',
    role: 'Org Admin',
    role_title: 'Org Admin',
    function: 'Executive',
    side: 'Quad',
    email: 'maya.singh@quad.example',
  },
  {
    id: 'u7',
    name: 'Ethan Rivera',
    role: 'Account Member',
    role_title: 'Account Member',
    function: 'Operations',
    side: 'Quad',
    email: 'ethan.rivera@quad.example',
  },
  {
    id: 'u8',
    name: 'Zoey Thomas',
    role: 'Account Member',
    role_title: 'Account Member',
    function: 'Operations',
    side: 'Quad',
    email: 'zoey.thomas@quad.example',
  },
]

const categories = [
  'Catalogs',
  'Direct Mail',
  'In-Store Marketing',
  'Packaging',
  'Logistics Services',
  'Marketing Services',
  'Digital Signage',
  'Digital',
]

// Ensure all accounts have people data and orders
let runtimeAccounts: Account[] = ensureAllAccountsPeople([...fullClientList])

// Run validation on startup
if (typeof window !== 'undefined') {
  const validationResult = validateSeedData(runtimeAccounts)
  printValidationReport(validationResult)
}

export const seedData: SeedData = {
  categories,
  users,
  get accounts() {
    return runtimeAccounts
  },
}

/**
 * Update accounts in memory (for demo purposes)
 */
export function updateAccounts(accounts: Account[]): void {
  runtimeAccounts = ensureAllAccountsPeople(accounts)
}

/**
 * Reset accounts to original state
 */
export function resetAccounts(): void {
  runtimeAccounts = ensureAllAccountsPeople([...fullClientList])
}
